import { Container, InputGroup, Stack, Table } from "rsuite";
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import { useCustomTheme } from "../../hooks/useCustomTheme";
import { ContentHeader } from "../../components/ContentHeader";
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from "../../components/CustomInput";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import { CustomButton } from "../../components/CustomButton";
import { CustomHeaderCell } from "../../components/CustomHeaderCell";
import { CustomCell } from "../../components/CustomCell";
import api from '../../services/api';
import { useAuth } from "../../hooks/auth";
import EditarCadastrarBanner from "./EditarCadastrar";
import { FaRegImage } from "react-icons/fa";

const { Column } = Table;

const Banner = () => {
  const { id_empresa } = useAuth();
  const [loading, setLoading] = useState(true);
  const [buscar, setBuscar] = useState('');
  const [modal, setModal] = useState(false);
  const [banners, setBanners] = useState([]);
  const [banner, setBanner] = useState(null);
  const { theme } = useCustomTheme();

  const filtro = banners.filter((b) => {
    return b.Descricao.toLowerCase().indexOf(buscar.toLowerCase()) !== -1;
  });

  const debounceSearch = debounce((valor) => {
    setBuscar(valor);
  }, 1000);

  const atualizar = useCallback(async () => {
    await api.get(`/banner/listarGestor/${id_empresa}`)
    .then((response) => {
      setBanners(response.data);
    })
    .catch((error) => {
      console.error("Erro ao buscar banners:", error);
    }).finally(() => setLoading(false));
  },[])

  const cadastrar = useCallback(() => {
    setBanner(null);
    setModal(true);
  },[]);

  const abrirDados = (banner) => {
    setBanner(banner)
    setModal(true);
  }

  useEffect(() => {
    debounceSearch(buscar ?? '');
  }, []);

  useEffect(() => {
    atualizar();
  },[])

  return(
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Banners"
        subtitle="Gerencie os banners da sua empresa"
        icon={FaRegImage}
        secondComponent={
          <InputGroup inside style={{ width: '40vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <Stack spacing={10}>
            <DuvidasButton tela="banner" />
            <CustomButton appearance="primary" onClick={() => cadastrar()}>
              <PlusIcon style={{ marginRight: 6 }} />
              Adicionar Banner
            </CustomButton>
          </Stack>
        }
      />

      <Table
        height={window.innerHeight - 60 - 90}
        bordered={true}
        loading={loading}
        data={filtro}
        width={'100%'}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhum cupom encontrado',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={4}
        >
          <CustomHeaderCell>Descrição</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>

          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                <CustomButton
                  appearance={rowData.Ativo ? 'primary' : 'ghost'}
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 10px',
                  }}
                  onClick={() => {}}
                >
                  {rowData.Ativo ? 'Sim' : 'Não'}
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>

          <CustomCell>
            {(rowData) => (
              <span>
                <CustomButton
                  color={theme.colors.warning}
                  appearance="ghost"
                  size="xs"
                  onClick={() => abrirDados(rowData)}
                >
                  Editar
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>
      </Table>
      {modal &&
        <EditarCadastrarBanner
          open={modal}
          onClose={() => setModal(false)}
          banner={banner}
          setBanner={setBanner}
          setBanners={setBanners}
        />}
    </Container>
  )
}

export default Banner;
